var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mobile-nav" }, [
    !_vm.opened
      ? _c("div", { staticClass: "main-menu" }, [
          _c(
            "div",
            { staticClass: "item-block" },
            [
              _c("menu-item", {
                attrs: {
                  text: "Solutions and insights",
                  caption:
                    "Use our corporate insights and engagement tools to discover, analyse and connect with Africa's private sector",
                },
                on: {
                  click: function ($event) {
                    return _vm.showSection("solutions")
                  },
                },
              }),
              _vm._v(" "),
              _c("arrow-right", {
                on: {
                  click: function ($event) {
                    return _vm.showSection("solutions")
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "item-block" },
            [
              _c("menu-item", {
                attrs: {
                  text: "Opportunities for African Businesses",
                  caption:
                    "Work with our partners to access financing and better integrate your African business into global markets",
                },
                on: {
                  click: function ($event) {
                    return _vm.showSection("opportunities")
                  },
                },
              }),
              _vm._v(" "),
              _c("arrow-right", {
                on: {
                  click: function ($event) {
                    return _vm.showSection("opportunities")
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "item-block" },
            [
              _c("menu-item", {
                attrs: {
                  text: "Engage with African Businesses",
                  caption:
                    "Identify leading companies via initiatives run by investment firms, multinationals and development partners",
                },
                on: {
                  click: function ($event) {
                    return _vm.showSection("invest")
                  },
                },
              }),
              _vm._v(" "),
              _c("arrow-right", {
                on: {
                  click: function ($event) {
                    return _vm.showSection("invest")
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "item-block" },
            [
              _c("menu-item", {
                attrs: {
                  text: "About us",
                  caption:
                    "Get to know more about our approach, meet the team or contact us",
                },
                on: {
                  click: function ($event) {
                    return _vm.showSection("about")
                  },
                },
              }),
              _vm._v(" "),
              _c("arrow-right", {
                on: {
                  click: function ($event) {
                    return _vm.showSection("about")
                  },
                },
              }),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.opened
      ? _c(
          "div",
          { staticClass: "nav-details" },
          [
            _c(
              "div",
              { staticClass: "details-header" },
              [
                _c("arrow-left", { on: { click: _vm.showMainMenu } }),
                _vm._v(" "),
                _c("h4", [_vm._v(_vm._s(_vm.selectedTitle))]),
              ],
              1
            ),
            _vm._v(" "),
            _vm.opened === "solutions"
              ? _c("solutions-menu", {
                  directives: [
                    {
                      name: "on-clickaway",
                      rawName: "v-on-clickaway",
                      value: _vm.hide,
                      expression: "hide",
                    },
                  ],
                  staticClass: "opened-menu",
                  on: { hide: _vm.hide },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.opened === "opportunities"
              ? _c("opportunities-menu", {
                  directives: [
                    {
                      name: "on-clickaway",
                      rawName: "v-on-clickaway",
                      value: _vm.hide,
                      expression: "hide",
                    },
                  ],
                  staticClass: "opened-menu",
                  on: { hide: _vm.hide },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.opened === "invest"
              ? _c("deals-menu", {
                  directives: [
                    {
                      name: "on-clickaway",
                      rawName: "v-on-clickaway",
                      value: _vm.hide,
                      expression: "hide",
                    },
                  ],
                  staticClass: "opened-menu",
                  on: { hide: _vm.hide },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.opened === "about"
              ? _c("about-menu", {
                  directives: [
                    {
                      name: "on-clickaway",
                      rawName: "v-on-clickaway",
                      value: _vm.hide,
                      expression: "hide",
                    },
                  ],
                  staticClass: "opened-menu",
                  on: { hide: _vm.hide },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }